
import { RadioGroup } from 'app/components/form/RadioGroup'
import { MaterialInput } from 'app/components/material';
import { cloneRetirementPerson, Gender, hasDOB, IRetirementPerson, isValidPerson, Profile, updateLifeExpectancy } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'

interface IGenderSelectorProps {
  name: string
  gender: Gender
  onChange: (gender: Gender) => void
}

class GenderSelector extends React.Component<IGenderSelectorProps, {}> {
  constructor(props, context) {
    super(props, context);
    // tslint:disable-next-line:no-console
    console.log('gender constructor here')
  }

  render() {
    const opts = [
        { label: 'Male', value: Gender.male},
        { label: 'Female', value: Gender.female}
    ]
    // tslint:disable-next-line:no-console
    console.log('gender.render running: ' + this.props.gender)

    return (
      <span className="GenderSelector">
        <RadioGroup name={this.props.name}
            key={this.props.gender}
            selectedValue={this.props.gender}
            parseValue={(v) => v}
            onChange={(value) => this.props.onChange(value as Gender)}
            noLabelBlock={true}
            options={opts} />
      </span>
    );
  }
}

export {
    GenderSelector
}



// WEBPACK FOOTER //
// ./src/app/components/GenderSelector/index.tsx